import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import './ServicesPage.css';

const ServicesPage = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useSelector((state) => state.language);
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  
  // بيانات التأمينات الكاملة
  const insuranceServices = [
    {
      id: 1,
      category: 'vehicle',
      icon: '🚗',
      title: {
        en: 'Compulsory Car Insurance',
        ar: 'تأمين المركبات الإلزامي'
      },
      description: {
        en: 'Mandatory insurance for all vehicles in Libya as per Libyan law. Covers third-party liability for bodily injury and property damage.',
        ar: 'تأمين إلزامي لجميع المركبات في ليبيا وفقًا للقانون الليبي. يغطي مسؤولية الطرف الثالث للإصابة الجسدية والأضرار المادية.'
      },
      features: {
        en: [
          'Covers third-party bodily injury up to 500,000 LYD',
          'Property damage coverage up to 100,000 LYD',
          'Valid throughout Libya',
          'Issued immediately'
        ],
        ar: [
          'يغطي إصابة الطرف الثالث حتى 500,000 دينار ليبي',
          'تغطية الأضرار المادية حتى 100,000 دينار ليبي',
          'ساري المفعول في جميع أنحاء ليبيا',
          'يصدر فورًا'
        ]
      },
      legalReference: {
        en: 'Libyan Insurance Law No. 20 of 2010',
        ar: 'قانون التأمين الليبي رقم 20 لسنة 2010'
      }
    },
    {
      id: 2,
      category: 'vehicle',
      icon: '🚙',
      title: {
        en: 'Complementary Car Insurance',
        ar: 'تأمين المركبات التكميلي'
      },
      description: {
        en: 'Comprehensive coverage beyond compulsory insurance. Includes theft, fire, natural disasters, and damage to your own vehicle.',
        ar: 'تغطية شاملة تتجاوز التأمين الإلزامي. تشمل السرقة، الحريق، الكوارث الطبيعية، والأضرار لمركبتك الخاصة.'
      },
      features: {
        en: [
          'Coverage for theft and burglary',
          'Fire and natural disaster protection',
          'Accidental damage to your vehicle',
          'Optional glass breakage coverage'
        ],
        ar: [
          'تغطية السرقة والسطو',
          'حماية من الحريق والكوارث الطبيعية',
          'أضرار عرضية لمركبتك',
          'تغطية كسر الزجاج اختيارية'
        ]
      }
    },
    {
      id: 3,
      category: 'travel',
      icon: '✈️',
      title: {
        en: 'Travelers Insurance',
        ar: 'تأمين المسافرين'
      },
      description: {
        en: 'Comprehensive protection for travelers worldwide. Covers medical emergencies, trip cancellation, lost luggage, and personal accidents.',
        ar: 'حماية شاملة للمسافرين حول العالم. تغطي الطوارئ الطبية، إلغاء الرحلة، فقدان الأمتعة، والحوادث الشخصية.'
      },
      features: {
        en: [
          'Emergency medical expenses up to $100,000',
          'Trip cancellation/interruption',
          'Lost/delayed baggage',
          '24/7 emergency assistance'
        ],
        ar: [
          'المصاريف الطبية الطارئة حتى 100,000 دولار',
          'إلغاء/مقاطعة الرحلة',
          'الأمتعة المفقودة/المتأخرة',
          'مساعدة طوارئ على مدار الساعة'
        ]
      }
    },
    {
      id: 4,
      category: 'aviation',
      icon: '🛩️',
      title: {
        en: 'Aviation Insurance',
        ar: 'تأمين الطيران'
      },
      description: {
        en: 'Specialized insurance for aircraft owners, operators, and aviation-related businesses. Covers hull damage, liability, and passenger risks.',
        ar: 'تأمين متخصص لملاك الطائرات والمشغلين والشركات المتعلقة بالطيران. يغطي أضرار الهيكل، المسؤولية، ومخاطر الركاب.'
      },
      features: {
        en: [
          'Hull all-risk coverage',
          'Third-party liability',
          'Passenger legal liability',
          'War and terrorism risk coverage'
        ],
        ar: [
          'تغطية جميع مخاطر الهيكل',
          'مسؤولية الطرف الثالث',
          'المسؤولية القانونية للركاب',
          'تغطية مخاطر الحرب والإرهاب'
        ]
      }
    },
    {
      id: 5,
      category: 'property',
      icon: '🔥',
      title: {
        en: 'Fire Insurance',
        ar: 'تأمين الحريق'
      },
      description: {
        en: 'Protection against fire damage to residential, commercial, and industrial properties. Includes coverage for fire, explosion, lightning, and smoke damage.',
        ar: 'حماية ضد أضرار الحريق للممتلكات السكنية والتجارية والصناعية. تشمل التغطية للحريق، الانفجار، الصواعق، وأضرار الدخان.'
      },
      features: {
        en: [
          'Fire and explosion coverage',
          'Lightning and thunderstorm damage',
          'Smoke and soot damage',
          'Alternative accommodation costs'
        ],
        ar: [
          'تغطية الحريق والانفجار',
          'أضرار الصواعق والعواصف الرعدية',
          'أضرار الدخان والسخام',
          'تكاليف الإقامة البديلة'
        ]
      }
    },
    {
      id: 6,
      category: 'energy',
      icon: '⚡',
      title: {
        en: 'Energy Insurance',
        ar: 'تأمين الطاقة'
      },
      description: {
        en: 'Specialized coverage for energy sector projects including oil, gas, and renewable energy. Designed for construction, operation, and liability risks.',
        ar: 'تغطية متخصصة لمشاريع قطاع الطاقة بما في ذلك النفط والغاز والطاقة المتجددة. مصممة لمخاطر البناء والتشغيل والمسؤولية.'
      },
      features: {
        en: [
          'Construction all-risk insurance',
          'Operational risk coverage',
          'Business interruption',
          'Environmental liability'
        ],
        ar: [
          'تأمين جميع مخاطر البناء',
          'تغطية مخاطر التشغيل',
          'انقطاع الأعمال',
          'المسؤولية البيئية'
        ]
      }
    },
    {
      id: 7,
      category: 'engineering',
      icon: '🏗️',
      title: {
        en: 'Engineering Insurance',
        ar: 'تأمين الهندسة'
      },
      description: {
        en: 'Comprehensive coverage for construction and engineering projects. Protects against material damage, third-party liability, and construction risks.',
        ar: 'تغطية شاملة لمشاريع البناء والهندسة. يحمي من الأضرار المادية، مسؤولية الطرف الثالث، ومخاطر البناء.'
      },
      features: {
        en: [
          'Contractors all-risk insurance',
          'Erection all-risk insurance',
          'Machinery breakdown',
          'Third-party liability'
        ],
        ar: [
          'تأمين جميع مخاطر المقاولين',
          'تأمين جميع مخاطر التركيب',
          'تلف الآلات',
          'مسؤولية الطرف الثالث'
        ]
      }
    },
    {
      id: 8,
      category: 'personal',
      icon: '🚑',
      title: {
        en: 'Personal Accident Insurance',
        ar: 'تأمين الحوادث الشخصية'
      },
      description: {
        en: 'Financial protection against accidental injuries, disability, or death. Provides lump sum payments for medical expenses and income replacement.',
        ar: 'حماية مالية ضد الإصابات العرضية، الإعاقة، أو الوفاة. يوفر دفعات مبلغ مقطوع للمصاريف الطبية واستبدال الدخل.'
      },
      features: {
        en: [
          'Accidental death coverage',
          'Permanent total/partial disability',
          'Temporary total disability',
          'Medical expenses reimbursement'
        ],
        ar: [
          'تغطية الوفاة العرضية',
          'إعاقة كلية/جزئية دائمة',
          'إعاقة كلية مؤقتة',
          'استرداد المصاريف الطبية'
        ]
      }
    },
    {
      id: 9,
      category: 'health',
      icon: '🏥',
      title: {
        en: 'Medical Insurance',
        ar: 'التأمين الطبي'
      },
      description: {
        en: 'Comprehensive healthcare coverage for individuals, families, and corporate groups. Includes hospitalization, outpatient care, and medication.',
        ar: 'تغطية رعاية صحية شاملة للأفراد والعائلات والمجموعات الشركاتية. تشمل الاستشفاء، الرعاية الخارجية، والأدوية.'
      },
      features: {
        en: [
          'Inpatient hospitalization',
          'Outpatient clinic visits',
          'Emergency room services',
          'Prescription medication'
        ],
        ar: [
          'الاستشفاء الداخلي',
          'زيارات العيادات الخارجية',
          'خدمات غرفة الطوارئ',
          'الأدوية الموصوفة'
        ]
      }
    },
    {
      id: 10,
      category: 'takaful',
      icon: '🕌',
      title: {
        en: 'Social Takaful Insurance',
        ar: 'التأمين التعاوني (التكافل)'
      },
      description: {
        en: 'Sharia-compliant cooperative insurance based on mutual assistance and shared responsibility. All operations comply with Islamic principles.',
        ar: 'تأمين تعاوني متوافق مع الشريعة الإسلامية قائم على التعاون والمسؤولية المشتركة. جميع العمليات تتوافق مع المبادئ الإسلامية.'
      },
      features: {
        en: [
          'Sharia-compliant operations',
          'No interest (riba) involved',
          'Risk-sharing principle',
          'Charity (tabarru) contributions'
        ],
        ar: [
          'عمليات متوافقة مع الشريعة',
          'لا تتعامل بالربا',
          'مبدأ تقاسم المخاطر',
          'مساهمات خيرية (تبرع)'
        ]
      }
    },
    {
      id: 11,
      category: 'property',
      icon: '🏘️',
      title: {
        en: 'Miscellaneous Accidents (Properties)',
        ar: 'تأمين الحوادث المتنوعة (الممتلكات)'
      },
      description: {
        en: 'Coverage for various property-related accidents including water damage, impact damage, theft, and malicious acts.',
        ar: 'تغطية لمختلف الحوادث المتعلقة بالممتلكات بما في ذلك أضرار المياه، أضرار الاصطدام، السرقة، والأعمال الخبيثة.'
      },
      features: {
        en: [
          'Water damage from plumbing',
          'Impact by vehicles/animals',
          'Theft and burglary',
          'Malicious damage'
        ],
        ar: [
          'أضرار المياه من السباكة',
          'اصطدام بالمركبات/الحيوانات',
          'السرقة والسطو',
          'أضرار خبيثة'
        ]
      }
    },
    {
      id: 12,
      category: 'liability',
      icon: '⚖️',
      title: {
        en: 'Miscellaneous Accidents (Liabilities)',
        ar: 'تأمين الحوادث المتنوعة (المسؤوليات)'
      },
      description: {
        en: 'Protection against third-party liability claims for bodily injury or property damage arising from various accidents.',
        ar: 'حماية ضد مطالبات المسؤولية تجاه الغير للإصابة الجسدية أو الأضرار المادية الناتجة عن حوادث متنوعة.'
      },
      features: {
        en: [
          'Public liability coverage',
          'Product liability',
          'Professional indemnity',
          'Employers liability'
        ],
        ar: [
          'تغطية المسؤولية العامة',
          'مسؤولية المنتج',
          'التعويض المهني',
          'مسؤولية صاحب العمل'
        ]
      }
    },
    {
      id: 13,
      category: 'property',
      icon: '📦',
      title: {
        en: 'Objects Insurance',
        ar: 'تأمين الأشياء'
      },
      description: {
        en: 'Coverage for valuable objects, equipment, and assets against theft, damage, loss, or destruction.',
        ar: 'تغطية للأشياء القيمة والمعدات والأصول ضد السرقة، التلف، الفقد، أو التدمير.'
      },
      features: {
        en: [
          'All-risk coverage for valuables',
          'Equipment breakdown',
          'Transit insurance',
          'Stock and inventory coverage'
        ],
        ar: [
          'تغطية جميع المخاطر للأشياء القيمة',
          'تلف المعدات',
          'تأمين النقل',
          'تغطية المخزون والجرد'
        ]
      }
    }
  ];

  // فئات التأمين
  const categories = [
    { id: 'all', label: { en: 'All Services', ar: 'جميع الخدمات' } },
    { id: 'vehicle', label: { en: 'Vehicle Insurance', ar: 'تأمين المركبات' } },
    { id: 'property', label: { en: 'Property Insurance', ar: 'تأمين الممتلكات' } },
    { id: 'travel', label: { en: 'Travel Insurance', ar: 'تأمين السفر' } },
    { id: 'health', label: { en: 'Health Insurance', ar: 'التأمين الصحي' } },
    { id: 'liability', label: { en: 'Liability Insurance', ar: 'تأمين المسؤولية' } },
    { id: 'engineering', label: { en: 'Engineering Insurance', ar: 'تأمين الهندسة' } },
    { id: 'takaful', label: { en: 'Takaful Insurance', ar: 'التأمين التكافلي' } }
  ];

  // تصفية الخدمات بناءً على الفئة والبحث
  const filteredServices = insuranceServices.filter(service => {
    const matchesCategory = activeCategory === 'all' || service.category === activeCategory;
    const matchesSearch = searchTerm === '' || 
      service.title[currentLanguage].toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.description[currentLanguage].toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="services-page">
      <Header />
      
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-content"
          >
            <h1>
              {currentLanguage === 'en' 
                ? 'Our Insurance Services' 
                : 'خدماتنا التأمينية'}
            </h1>
            <p>
              {currentLanguage === 'en' 
                ? 'Comprehensive protection solutions tailored to your needs. Discover our range of insurance services designed to provide peace of mind and financial security.' 
                : 'حلول حماية شاملة مصممة خصيصًا لاحتياجاتك. اكتشف مجموعة خدماتنا التأمينية المصممة لتوفير راحة البال والأمن المالي.'}
            </p>
          </motion.div>
        </div>
      </section>

      {/* الفلاتر والبحث */}
      <section className="services-filters">
        <div className="container">
          <div className="filters-container">
            {/* شريط البحث */}
            <div className="search-container">
              <input
                type="text"
                placeholder={currentLanguage === 'en' ? 'Search services...' : 'ابحث في الخدمات...'}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              <span className="search-icon">🔍</span>
            </div>

            {/* فئات التأمين */}
            <div className="categories-container">
              <div className="categories-scroll">
                {categories.map((category) => (
                  <motion.button
                    key={category.id}
                    className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                    onClick={() => setActiveCategory(category.id)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {category.label[currentLanguage]}
                  </motion.button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* قائمة الخدمات */}
      <section className="services-list">
        <div className="container">
          <div className="services-grid">
            {filteredServices.map((service, index) => (
              <motion.div
                key={service.id}
                className="service-card"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -10, boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)' }}
              >
                <div className="service-icon">
                  <span>{service.icon}</span>
                </div>
                
                <div className="service-content">
                  <h3>{service.title[currentLanguage]}</h3>
                  <p className="service-description">{service.description[currentLanguage]}</p>
                  
                  <div className="service-features">
                    <h4>{currentLanguage === 'en' ? 'Key Features:' : 'المميزات الرئيسية:'}</h4>
                    <ul>
                      {service.features[currentLanguage].map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </div>

                  {service.legalReference && (
                    <div className="legal-reference">
                      <strong>{currentLanguage === 'en' ? 'Legal Reference:' : 'المرجع القانوني:'}</strong>
                      <p>{service.legalReference[currentLanguage]}</p>
                    </div>
                  )}
                </div>

                <div className="service-actions">
                  <motion.button
                    className="inquire-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => navigate('/contact')}
                  >
                    {currentLanguage === 'en' ? 'Request Quote' : 'طلب عرض سعر'}
                  </motion.button>
                  <motion.button
                    className="details-btn"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {currentLanguage === 'en' ? 'More Details' : 'المزيد من التفاصيل'}
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* قسم الأسئلة الشائعة */}
      <section className="faq-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>{currentLanguage === 'en' ? 'Frequently Asked Questions' : 'الأسئلة الشائعة'}</h2>
            
            <div className="faq-grid">
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'How to choose the right insurance?' : 'كيف أختار التأمين المناسب؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Consider your assets, risks, and budget. Our experts can help you assess your needs and recommend suitable coverage.' 
                    : 'فكر في أصولك ومخاطرك وميزانيتك. يمكن لخبرائنا مساعدتك في تقييم احتياجاتك والتوصية بالتغطية المناسبة.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'What documents are required?' : 'ما هي المستندات المطلوبة؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Typically: ID copy, proof of ownership, and previous insurance details (if applicable). Requirements vary by insurance type.' 
                    : 'عادة: نسخة من الهوية، إثبات الملكية، وتفاصيل التأمين السابق (إن وجد). المتطلبات تختلف حسب نوع التأمين.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'How long does processing take?' : 'كم تستغرق المعالجة؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Compulsory car insurance: immediate. Other insurances: 1-3 business days depending on complexity and documents.' 
                    : 'تأمين المركبات الإلزامي: فوري. أنواع التأمين الأخرى: 1-3 أيام عمل حسب التعقيد والمستندات.'}
                </p>
              </div>
              
              <div className="faq-item">
                <h3>{currentLanguage === 'en' ? 'Can I cancel my policy?' : 'هل يمكنني إلغاء وثيقتي؟'}</h3>
                <p>
                  {currentLanguage === 'en' 
                    ? 'Yes, most policies can be cancelled. Refunds are calculated based on elapsed time and policy terms.' 
                    : 'نعم، يمكن إلغاء معظم الوثائق. يتم حساب المبالغ المستردة بناءً على الوقت المنقضى وشروط الوثيقة.'}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* قسم الـ CTA */}
      <section className="services-cta">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="cta-content"
          >
            <h2>{currentLanguage === 'en' ? 'Need Personalized Advice?' : 'تحتاج إلى نصيحة شخصية؟'}</h2>
            <p>
              {currentLanguage === 'en' 
                ? 'Our insurance experts are ready to help you choose the perfect coverage for your specific needs.' 
                : 'خبراء التأمين لدينا جاهزون لمساعدتك في اختيار التغطية المثالية لاحتياجاتك الخاصة.'}
            </p>
            <motion.button
              className="cta-button"
              whileHover={{ scale: 1.05, boxShadow: '0 10px 25px rgba(109, 40, 217, 0.3)' }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/contact')}
            >
              {currentLanguage === 'en' ? 'Contact Us Now' : 'اتصل بنا الآن'}
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;